import { ApplicationData, getApplicationName, ReportsApplication, ReportsTypes } from '../model'
import { Application } from '../../../remote-api/models';

export class ReportsService {

  public static filterApplicationData(data: { applicationData: ApplicationData[], type: string }, reportApplications: ReportsApplication[], resourceApplications: Application[]) {
    return data.applicationData.map(appData => {
      const maybeRTFApp = reportApplications.find(a => a.name === appData.appId && a.targetId === appData.targetId)
      if (maybeRTFApp && maybeRTFApp.targetType === 'MC') {
        return {...appData, appId: maybeRTFApp.id, appName: appData.appId}
      } else {
        return {...appData, appName: getApplicationName(appData.appId, appData.appName, resourceApplications, reportApplications)}
      }
    })
  }
}
